import { useConnection } from "@/components/features/items/edit/_shared/ui/components/main/questions/connection/hooks";

import { useProductOptionFormModelContext } from "../../../../context";

export const useOptionPlanConnection = () => {
	const { viewModel, onSetViewModel, queryData } = useProductOptionFormModelContext();
	const { availablePlanIDs } = viewModel;
	const { planNameAndIDOptions } = queryData.connection;

	return useConnection<"availablePlanIDs">({
		availableItemIDs: availablePlanIDs, //
		nameAndIDOptions: planNameAndIDOptions,
		keyOfValue: "availablePlanIDs",
		onSetViewModel,
	});
};
